export const THEME_COLOR_MODE_KEY = 'colorMode';
